// extracted by mini-css-extract-plugin
export default {"img":"ImageComponent_img__noOb0"};